import { Route } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";
import AdminScreen from "../../features/AdminView/pages/Admin";
import { ComingSoon } from "../../shared/base-components/ComingSoon";
import CoaExcelView from "../../features/CoaView/pages/CoaExcelView/CoaExcelView";
import { CoaList } from "../../features/CoaView/pages/CoaList/CoaList";
import { DeliverableDetails } from "../../features/DeliverableView/pages/DeliverableDetails/DeliverableDetails";
import { DeliverableList } from "../../features/DeliverableView/pages/DeliverableList/DeliverableList";
import { TemplateCreate } from "../../features/TemplateView/pages/TemplateCreate/TemplateCreate";
import TemplateExcelView from "../../features/TemplateView/pages/TemplateExcelView/TemplateExcelView";
import { TemplateList } from "../../features/TemplateView/pages/TemplateList/TemplateList";
import UserAccessEdit from "../../features/UserAccessView/pages/UserAccessEdit";
import UserAccess from "../../features/UserAccessView/pages/UserAccessList";
import {
  EXCEL_VIEW_ROUTE_KEY,
  LANDING_ROUTE_KEY,
  NAVBAR_KEY,
} from "../../shared/utils/CommonConstants";
import { SidebarLayout } from "../../shared/base-components/SidebarLayout/SidebarLayout";
import { DeliverableMenu } from "../../shared/screen-components/DeliverableMenuComponent/DeliverableMenuComponent";
import { SheetCreate } from "../../features/TemplateView/pages/TemplateCreate/SheetCreate/SheetCreate";
import AgGridView from "../../features/DeliverableView/pages/AgGridView/AgGridView";
import { ProjectList } from "../../features/ProjectView/pages/ProjectList/ProjectList";
import { ProjectDeliverables } from "../../features/ProjectView/pages/ProjectDeliverables/ProjectDeliverables";
import { ClientList } from "../../features/ClientView/pages/ClientList/ClientList";
import TieringView from "../../features/TieringView/pages/TieringView/TieringView";
import { EngagementList } from "../../features/EngagementView/pages/EngagementList/EngagementList";
import { EngagementDetails } from "../../features/EngagementView/pages/EngagementDetails/EngagementDetails";
import { CreateEngagement } from "../../features/EngagementView/pages/CreateEngagement/CreateEngagement";
import { EntityList } from "../../features/EntityView/pages/EntityList/EntityList";
import { EntityDetails } from "../../features/EntityView/pages/EntityDetails/EntityDetails";
import { M1Differences } from "../../features/FinancialsView/M1Differences/M1Differences";
import { PriorYearCapital } from "../../features/FinancialsView/PriorYearCapital/PriorYearCapital";
import { FixedAssets } from "../../features/FinancialsView/FixedAssets/FixedAssets";
import { AuditLog } from "../../features/SettingsView/AuditLog/AuditLog";
import { PartnershipSettings } from "../../features/ConfigurationsView/PartnershipSettings/PartnershipSettings";
import { CalcProfile } from "../../features/ConfigurationsView/CalcProfile/CalcProfile";
import { Templates } from "../../features/ConfigurationsView/Templates/Templates";
import { StandardCalculations } from "../../features/SettingsView/StandardCalculations/StandardCalculations";
import { UserManagement } from "../../features/SettingsView/UserManagement/UserManagement";
import { Project } from "../../features/CalculationsView/Project/Project";
import { ProjectWorkspace } from "../../features/CalculationsView/ProjectWorkspace/ProjectWorkspace";
import { UploadInput } from "../../features/CalculationsView/UploadInput/UploadInput";
import { GenerateTaxForm } from "../../features/CalculationsView/GenerateTaxForm/GenerateTaxForm";
import { CascadeView } from "../../features/CalculationsView/Cascade/CascadeView";
import { AccountMapping } from "../../features/CalculationsView/AccountMapping/AccountMapping";
import { ClientOverview } from "../../features/ClientOverview/ClientOverview";

const AuthRoutes = [
  // Full sidebar layout — Project List and legacy screens
  <Route element={<SidebarLayout />} key={NAVBAR_KEY}>
    <Route
      key={LANDING_ROUTE_KEY}
      caseSensitive
      path="/projects"
      element={<AuthGuard component={<ProjectList />} />}
    />
    <Route
      key={LANDING_ROUTE_KEY}
      caseSensitive
      path="/deliverable"
      element={<AuthGuard component={<DeliverableList />} />}
    />
    <Route
      key={LANDING_ROUTE_KEY}
      caseSensitive
      path="/template"
      element={<AuthGuard component={<TemplateList />} />}
    />
    <Route
      key={LANDING_ROUTE_KEY}
      caseSensitive
      path="/template/create"
      element={<AuthGuard component={<TemplateCreate />} />}
    />
    <Route
      key={LANDING_ROUTE_KEY}
      caseSensitive
      path="/template/:templateId/sheet/:sheetId"
      element={<AuthGuard component={<SheetCreate />} />}
    />
    <Route
      key={LANDING_ROUTE_KEY}
      caseSensitive
      path="/coa"
      element={<AuthGuard component={<CoaList />} />}
    />
    <Route
      key={LANDING_ROUTE_KEY}
      caseSensitive
      path="/admin"
      element={<AuthGuard component={<AdminScreen />} />}
    />
    <Route
      key="client-list"
      caseSensitive
      path="/clients"
      element={<AuthGuard component={<ClientList />} />}
    />
    <Route
      key="client-overview"
      caseSensitive
      path="/overview"
      element={<AuthGuard component={<ClientOverview />} />}
    />
    <Route
      key="tiering"
      caseSensitive
      path="/tiering/:entityId"
      element={<AuthGuard component={<TieringView />} />}
    />
    <Route
      key="tiering-root"
      caseSensitive
      path="/tiering"
      element={<AuthGuard component={<TieringView />} />}
    />
    <Route
      key="engagement-list"
      caseSensitive
      path="/engagements"
      element={<AuthGuard component={<EngagementList />} />}
    />
    <Route
      key="engagement-create"
      caseSensitive
      path="/engagements/create"
      element={<AuthGuard component={<CreateEngagement />} />}
    />
    <Route
      key="engagement-details"
      path="/engagements/:id"
      element={<AuthGuard component={<EngagementDetails />} />}
    />
    <Route
      key="project-deliverables"
      path="/projects/:projectId"
      element={<AuthGuard component={<ProjectDeliverables />} />}
    />
    <Route
      key="entity-list"
      caseSensitive
      path="/entities"
      element={<AuthGuard component={<EntityList />} />}
    />
    <Route
      key="entity-details"
      path="/entities/:id"
      element={<AuthGuard component={<EntityDetails />} />}
    />
    <Route path="/activities" element={<AuthGuard component={<ComingSoon title="Activities" />} />} />
    <Route path="/configurations/settings" element={<AuthGuard component={<PartnershipSettings />} />} />
    <Route path="/configurations/calc-profile" element={<AuthGuard component={<CalcProfile />} />} />
    <Route path="/configurations/templates" element={<AuthGuard component={<Templates />} />} />
    <Route path="/financials/capital" element={<AuthGuard component={<PriorYearCapital />} />} />
    <Route path="/financials/m1" element={<AuthGuard component={<M1Differences />} />} />
    <Route path="/financials/assets" element={<AuthGuard component={<FixedAssets />} />} />
    <Route path="/financials/coa" element={<AuthGuard component={<ComingSoon title="CoA Mapping" />} />} />
    <Route path="/calculations/project" element={<AuthGuard component={<Project />} />} />
    <Route path="/calculations/project/:projectId" element={<AuthGuard component={<Project />} />} />
    <Route path="/calculations/project/:projectId/workspace" element={<AuthGuard component={<ProjectWorkspace />} />} />
    <Route path="/calculations/cascade" element={<AuthGuard component={<CascadeView />} />} />
    <Route path="/calculations/roll-forward" element={<AuthGuard component={<ComingSoon title="Roll Forward" />} />} />
    <Route path="/calculations/upload" element={<AuthGuard component={<UploadInput />} />} />
    <Route path="/calculations/account-mapping" element={<AuthGuard component={<AccountMapping />} />} />
    <Route path="/calculations/revision" element={<AuthGuard component={<ComingSoon title="Revision History" />} />} />
    <Route path="/tax-form" element={<AuthGuard component={<GenerateTaxForm />} />} />
    <Route path="/settings/libraries" element={<AuthGuard component={<ComingSoon title="Libraries" />} />} />
    <Route path="/settings/accounts" element={<AuthGuard component={<ComingSoon title="Accounts & M-1 Settings" />} />} />
    <Route path="/settings/calculations" element={<AuthGuard component={<StandardCalculations />} />} />
    <Route path="/settings/users" element={<AuthGuard component={<UserManagement />} />} />
    <Route path="/settings/audit" element={<AuthGuard component={<AuditLog />} />} />
  </Route>,


  // DeliverableMenu layout — AG Grid, details, user access
  <Route element={<DeliverableMenu />} key={NAVBAR_KEY}>
    <Route
      key={LANDING_ROUTE_KEY}
      path="/deliverable/:deliverableId"
      element={<AuthGuard component={<DeliverableDetails />} />}
    />
    <Route
      key={EXCEL_VIEW_ROUTE_KEY}
      path="/deliverable/:deliverableId/:sheetId"
      element={<AuthGuard component={<AgGridView />} />}
    />
    <Route
      key={LANDING_ROUTE_KEY}
      path="/deliverable/user-access/:deliverableId"
      element={<AuthGuard component={<UserAccess />} />}
    />
    <Route
      key={LANDING_ROUTE_KEY}
      path="/deliverable/user-access/:deliverableId/edit"
      element={<AuthGuard component={<UserAccessEdit />} />}
    />
  </Route>,
  <Route
    key={EXCEL_VIEW_ROUTE_KEY}
    path="/template/:deliverableId/sheets/:sheetId"
    element={<AuthGuard component={<TemplateExcelView />} />}
  />,
  <Route
    key={EXCEL_VIEW_ROUTE_KEY}
    path="/coa/:deliverableId"
    element={<AuthGuard component={<CoaExcelView />} />}
  />,
];

export default AuthRoutes;
